module.exports = __webpack_public_path__ + "static/company_location-80849916636079d1b6656684c870f115.png";